import { render, staticRenderFns } from "./deleteFeeConfig.vue?vue&type=template&id=11148be5&scoped=true"
import script from "./deleteFeeConfig.vue?vue&type=script&lang=js"
export * from "./deleteFeeConfig.vue?vue&type=script&lang=js"
import style0 from "./deleteFeeConfig.vue?vue&type=style&index=0&id=11148be5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11148be5",
  null
  
)

export default component.exports